// extracted by mini-css-extract-plugin
export default {"rightSidebarWrapper":"rightSidebarWrapper__lUczsZEBARD_"};